<!--Barra de navegación de organizador LITE-->
<template>
  <v-container fluid class="pa-0 ma-0">
    <v-toolbar
      :class="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?'':'primary'"
      :dark="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?true:false"
    >
      <v-toolbar-title class="headline mr-5">
        <v-img src="@/assets/logo-WC-solo.png" width="45px" height="auto"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn class="text-unset" text exact @click="userLogout()" dark>Cerrar sesión</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </v-container>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      sidenav: false,
      menuItems: [
        { title: "Inicio", link: "/" },
        { title: "Eventirijilloss", link: "/eventos" },
        //{ title: "Afiliaciones", link: "/afiliaciones" },
        { title: "¿Cómo funciona?", link: "/como-funciona" },
        { title: "Nosotros", link: "/nosotros" }
      ],
      message: ""
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("event", ["currentEvent"])
  },
  methods: {
    ...mapMutations("user", ["logout"]),
    ...mapMutations("notifications", ["show"]),
    userLogout() {
      this.logout();
      this.$router.push("/login");
    },
    home() {
      this.$router.push("/");
    },
    onCopy: function(e) {
      this.show({
        text: "¡Se ha copiado la url de los eventos al portapapeles! 😄"
      });
    },
    onError: function(e) {
      this.show({ text: "¡Hubo un problema al copiar la url de los eventos!" });
    }
  },
  created() {
    this.message = `https://v2.wechamber.mx/eventos-organizador/${this.user.id}`;
  }
};
</script>
<style scoped>
.v-application a {
  color: white;
}
.text-unset {
  text-transform: unset;
}
</style>